import React from 'react';
import Logo from "../Components/Logo";
import { useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import Video from "../Assets/Images/video.mp4";

export default function Splash(props) {
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
            const token = match ? match[2] : null;
            if(token) {
                navigate('/home');
                return;
            }
            navigate('/login');
        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash " >

                <div className="row">
                    <div className="col-12  video-player-wrapper m-2">
                        <video className="video-player w-100" playsInline="playsinline" loop autoPlay={true} muted={true} >
                            <source src={Video} type="video/mp4" />
                        </video>
                    </div>
                </div>
                <div className="row splash-texts">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 ">
                                <Logo size={130} />
                            </div>
                            <h2 className="col-12 text-center mt-4 title text-white fw-bold">
                                نیرو گستران  خراسان
                            </h2>
                            <h6 className="col-12 text-center mt-4 text-white-50 text-small-1">
                               انبار برگشتی
                            </h6>
                            <div className="col-12 text-center fixed-bottom mb-5 pb-4">
                                <div className="spinner-grow text-primary-color" role="status">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
